import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';

export interface ICellRendererParamsForFormScheduleListGridAction extends ICellRendererParams {
    canDelete(params: ICellRendererParamsForFormScheduleListGridAction): boolean;

    canUndoDelete(params: ICellRendererParamsForFormScheduleListGridAction): boolean;

    delete: (params: ICellRendererParamsForFormScheduleListGridAction) => void;
    undoDelete: (params: ICellRendererParamsForFormScheduleListGridAction) => void;
}

@Component({
    selector: 'form-schedule-list-grid-action-cell',
    template: `
    @if (params.canDelete(params)) {
      <button class="ace-btn has-icon btn-primary btn-danger grid-action-button" title="Delete" (click)="params.delete(params)">
        <i class="fa fa-trash"></i>
      </button>
    }
    @if (params.canUndoDelete(params)) {
      <button class="ace-btn has-icon success-button grid-action-button" title="Undo Delete" (click)="params.undoDelete(params)">
        <i class="fa fa-undo"></i>
      </button>
    }
    `,
    standalone: false
})
export class FormScheduleListGridActionCellRendererComponent implements ICellRendererAngularComp, OnDestroy {
    private _editModeSub: Subscription;

    params: ICellRendererParamsForFormScheduleListGridAction;

    agInit(params: ICellRendererParamsForFormScheduleListGridAction): void {
        this.params = params;
    }

    ngOnDestroy(): void {
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
